import React, { useState, useEffect } from 'react';
import { get, put } from '../utils/api';
const fmt = n => '\u20a6' + Number(n||0).toLocaleString('en-NG');

export default function PendingRefunds() {
  const [refunds, setRefunds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [rejectModal, setRejectModal] = useState(null);
  const [rejectReason, setRejectReason] = useState('');

  const load = () => {
    setLoading(true);
    get('/refunds/pending').then(d => setRefunds(d.data||[])).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const handleApprove = async (id, name) => {
    if (!window.confirm('Approve refund for '+name+'? This will reduce the invoice amount paid and record an outflow in cashbook.')) return;
    try { await put('/refunds/'+id+'/approve', {}); load(); }
    catch (err) { alert(err.message); }
  };

  const handleReject = async () => {
    try { await put('/refunds/'+rejectModal.id+'/reject', { rejection_reason: rejectReason }); setRejectModal(null); setRejectReason(''); load(); }
    catch (err) { alert(err.message); }
  };

  return (
    <div>
      <div className="flex-between mb-lg">
        <div>
          <h2 className="page-title">Pending Refund Requests</h2>
          <p className="text-muted text-sm" style={{marginTop:4}}>Review and approve or reject customer refund requests</p>
        </div>
        <button className="btn btn-outline btn-sm" onClick={load}>↻ Refresh</button>
      </div>

      {loading ? <div className="spinner"></div> : refunds.length === 0 ? (
        <div className="empty-state">
          <h3>No pending refunds</h3>
          <p>All refund requests have been reviewed.</p>
        </div>
      ) : (
        <div>
          {refunds.map(r => (
            <div key={r.id} style={{background:'#fff',border:'1px solid var(--border-light)',borderRadius:10,
              padding:20,marginBottom:14,boxShadow:'var(--shadow)'}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:14}}>
                <div>
                  <div style={{fontSize:11,color:'#8A8A8A',marginBottom:4}}>Invoice {r.invoice_number} — {r.customer_name}</div>
                  <div style={{fontFamily:'Cormorant Garamond,serif',fontSize:'1.6rem',fontWeight:700,color:'#8F2E24'}}>
                    {fmt(r.amount)}
                  </div>
                  <div style={{fontSize:12,color:'#3B2A21',fontWeight:500,marginTop:4}}>{r.reason}</div>
                  <div style={{fontSize:11,color:'#8A8A8A',marginTop:4}}>
                    Requested by <strong>{r.requested_by_name}</strong> on {new Date(r.created_at).toLocaleDateString('en-NG')}
                  </div>
                  <div style={{fontSize:11,color:'#8A8A8A',marginTop:2}}>
                    Invoice Total: {fmt(r.invoice_total)} | 
                    <span style={{color:r.refund_type==='full'?'#8F2E24':'#8B5E0A',fontWeight:600,marginLeft:6}}>
                      {r.refund_type==='full'?'Full Refund':'Partial Refund'}
                    </span>
                  </div>
                </div>
                <div style={{display:'flex',gap:8}}>
                  <button className="btn btn-sm" style={{background:'#2E6B3A',color:'#fff',border:'none',padding:'10px 20px'}}
                    onClick={() => handleApprove(r.id, r.customer_name)}>
                    ✓ Approve
                  </button>
                  <button className="btn btn-danger btn-sm" style={{padding:'10px 20px'}}
                    onClick={() => { setRejectModal(r); setRejectReason(''); }}>
                    ✗ Reject
                  </button>
                </div>
              </div>

              {r.bank_name && (
                <div style={{background:'#F2EFE7',borderRadius:8,padding:'10px 14px',fontSize:12}}>
                  <span style={{color:'#8A8A8A',marginRight:8}}>Refund to:</span>
                  <strong>{r.account_name}</strong> — {r.bank_name} | {r.account_number}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {rejectModal && (
        <div className="modal-overlay">
          <div className="modal" style={{maxWidth:420}}>
            <div className="modal-hdr">
              <span className="modal-title">Reject Refund — {rejectModal.customer_name}</span>
              <button className="btn btn-ghost btn-sm" onClick={() => setRejectModal(null)}>X</button>
            </div>
            <div className="modal-body">
              <div style={{marginBottom:12,fontSize:13,color:'#3B2A21'}}>
                Refund amount: <strong style={{color:'#8F2E24'}}>{fmt(rejectModal.amount)}</strong>
              </div>
              <div className="form-group">
                <label className="form-label">Reason for Rejection *</label>
                <textarea className="form-control" rows={3} value={rejectReason}
                  onChange={e=>setRejectReason(e.target.value)}
                  placeholder="Explain why this refund is being rejected..." />
              </div>
            </div>
            <div className="modal-ftr">
              <button className="btn btn-outline" onClick={() => setRejectModal(null)}>Cancel</button>
              <button className="btn btn-danger" onClick={handleReject} disabled={!rejectReason}>
                Reject Refund
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
